import React from "react";
import { observer } from "mobx-react";
import { Button } from "antd";
import {
    ExpandAltOutlined,
    ShrinkOutlined,
    PlusCircleOutlined,
    MenuOutlined,
} from "@ant-design/icons";

import "./style/modal.scoped.scss";

const TITLE_HIDE_THRESHOLD = 450;

const Header = observer(({ expanded, onCreate, onToggle, onDrawerClick, collapsedWidth }) => {
    const showTitle = expanded || collapsedWidth >= TITLE_HIDE_THRESHOLD;

    return (
        <div className="header">
            {!expanded && (
                <Button
                    className="drawerButton"
                    icon={<MenuOutlined />}
                    type="text"
                    onClick={onDrawerClick}
                ></Button>
            )}
            <div className="title">
                {showTitle && "CAPTIS Copilot Chat"}
                <Button
                    icon={<PlusCircleOutlined />}
                    type="primary"
                    onClick={onCreate}
                    className="new-button"
                >
                    New Chat
                </Button>
            </div>
            <div className="actions">
                {!expanded && (
                    <Button
                        icon={<ExpandAltOutlined />}
                        type="text"
                        onClick={() => onToggle(true)}
                    ></Button>
                )}

                {expanded && (
                    <Button
                        icon={<ShrinkOutlined />}
                        type="text"
                        onClick={() => onToggle(false)}
                    ></Button>
                )}
            </div>
        </div>
    );
});

export default Header;
